export const BASE_URL = "https://api.eepartner.ba";
